import React from 'react'
import styles from './RouteSplitter.scss'
import {Icon} from 'common/Icon'
import {Distance} from 'common/units'

export class RouteSplitter extends React.PureComponent {
  onClose = () => {
    this.props.closeRouteSplitter()
    this.props.unmountComponent()
  }

  render () {
    const {route} = this.props

    const threeMiles = 4828.032 // This value is 3 miles in meters

    return (
      <div className={styles.RouteSplitter}>
        <div className={styles.controls} onClick={() => this.onClose()}>
          <Icon i='ios-arrow-back' size={24} />
          Return to the Route Planner
        </div>
        <div className={styles.header}>
          Split Route
        </div>
        <div className={styles.helpText}>
          <p>
            Click anywhere on the route or elevation profile to split the route at that point.
          </p>
          {route.pois && route.pois.length > 0 && (
            <div>
              <p>Points of Interest (POI) on the route will be associated with the closest route following the split.</p>
              <p>POI that fall within <Distance value={threeMiles} /> of both routes will be copied and associated with both resulting routes following the split</p>
            </div>
          )}
        </div>
      </div>
    )
  }
}
